import { useEffect } from 'react';
import styled from 'styled-components';
import { useResolveController, useService } from '@visiba/instantiation';
import { ScreenRedRobinSessionIframeController } from './screen_session_iframe.controller';
import { withTranslation } from '@application/i18n/with_translation';
import { tokens } from '@cellula/react-theme-patient';

const StyledIframe = styled.iframe`
	width: 600px;
	height: 840px;

	max-height: calc(100vh - ${tokens.size.x7}); // Total height with outlet header area subtracted
	min-height: 650px;
	min-width: 320px;
	max-width: 100%;
	border: 0;
	border-top: 1px solid ${tokens.color.border.default};

	${tokens.breakpointQuery.small} {
		max-height: calc(
			100vh - var(--header-height) - ${tokens.size.x6} - ${tokens.size.x7} - ${tokens.size.x1}
		); // Height subtracted with Page header, Margin and Outlet header + 1 for some space
	}

	/* @media screen and (max-height: 800px) {
		max-height: 650px;
	} */
`;

interface ScreenRedRobinSessionIframeProps {}
export function ScreenRedRobinSessionIframe(_: ScreenRedRobinSessionIframeProps) {
	const controller = useResolveController(ScreenRedRobinSessionIframeController);

	function handlePostEventFromIframe(messageEvent: MessageEvent) {
		const { event, data } = messageEvent.data;
		if (data === undefined) return;

		if (event === 'RedRobinSessionCompleted') {
			try {
				const { url } = JSON.parse(data);
				controller.navigateToExitUrl(url);
			} catch (error) {
				// noop
			}
		}
	}

	useEffect(function whenMounted() {
		window.addEventListener('message', handlePostEventFromIframe, false);

		return () => {
			window.removeEventListener('message', handlePostEventFromIframe, false);
		};
	}, []);

	if (!controller.viewData.value.sessionUrl) {
		return null;
	}

	return <StyledIframe title={withTranslation('View.RedRobin.Title')} src={controller.viewData.value.sessionUrl} />;
}
